<template>
  <div class="row m-0 BlogRoot mb-3" v-if="blogCategories && blogPosts">
    <h1 v-if="msg">{{ msg }}</h1>
    <div class="col-12 col-md-8 col-sm-12">
      <b-tabs :value="tabIndex">
        <b-tab
          class="card card-default border-0"
          :title="blogCat.title"
          @click="
            (evt) => {
              $emit('loadBlogCategory', { cat: blogCat, page: 1 });
            }
          "
          v-for="blogCat in blogCategories"
          :key="blogCat.title"
          :active="blogCat == blogCategories[tabIndex]"
        >
          <div class="card-body vertical-align px-0 pt-3 pb-0">
            <div class="col-12 col-md-10 col-sm-10">
              <h1>{{ blogCat.title }}</h1>
              <p class="subdued">
                <LinkToTradespoon
                  :text="blogCat.description"
                  :promotion_id="blogCat.tradespoonId"
                />
              </p>
            </div>
            <div class="col-12 col-md-2 col-sm-2 pb-3 pb-md-0">
              <img
                class="img-fluid rounded-2 center-block"
                alt="Trading Guide"
                :src="'/images/' + blogCat.imageUrl"
              />
            </div>
          </div>
        </b-tab>
      </b-tabs>
      <div class="input-group col-md-8 col-xl-6 mb-4">
        <input
          class="form-control py-2"
          type="search"
          value="search"
          id="example-search-input"
          v-model="search_text"
        />
        <span class="input-group-append">
          <button
            class="btn btn-outline-secondary"
            type="button"
            @click="
              $emit('search', {
                CatId: blogCategories[tabIndex].id,
                Phrase: search_text,
                PerPage: 4,
                SkipPages: 0,
              })
            "
          >
            <i class="fa fa-search"></i>
          </button>
        </span>
      </div>
      <div v-if="blogPosts.length > 0">
        <div
          class="card card-default border-0"
          :title="blogPost.title"
          active
          v-for="blogPost in blogPosts"
          :key="blogPost.title"
        >
          <blog-post :blogPost="blogPost" />
        </div>
      </div>

      <div v-else>
        <div class="card card-default">
          <h5>No results</h5>
        </div>
      </div>

      <b-pagination
        class="mt-3"
        :value="currentPage"
        @change="paginationClicked"
        :totalRows="totalRows"
        :per-page="perPage"
      />
    </div>
    <div class="col-12 col-md-4 col-sm-12">
      <side-menu
        :recentPostsItems="recentPostsItems"
        :archiveItems="archiveItems"
      />
    </div>
  </div>
</template>
<script>
import LinkToTradespoon from "./LinkToTradespoon.vue";
import SideMenu from "./SideMenu.vue";
import BlogPost from "./BlogPost.vue";
export default {
  name: "Blog",
  props: {
    showSearch: Boolean,
    msg: String,
    recentPostsItems: Array,
    archiveItems: Array,
    blogCategories: Array,
    blogPosts: Array,
    currentPage: Number,
    totalRows: Number,
    tabIndex: Number,
  },
  data() {
    return {
      search_text: "",
      create: window.admin !== undefined,
      perPage: 4,
    };
  },
  components: {
    SideMenu,
    BlogPost,
    LinkToTradespoon,
  },

  methods: {
    paginationClicked(ind) {
      if (!this.showSearch)
        this.$emit("loadBlogCategory", {
          cat: this.blogCategories[this.tabIndex],
          page: ind,
        });
      else
        this.$emit("search", {
          CatId: this.blogCategories[this.tabIndex].id,
          Phrase: this.search_text,
          PerPage: 4,
          SkipPages: ind - 1,
        });
      window.scroll({
        top: 0,
        left: 0,
        behavior: "auto",
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.BlogRoot {
}
</style>